import 'script-loader!jquery';
import 'script-loader!bootstrap/dist/js/bootstrap.bundle.min.js';
import 'script-loader!lightslider';
import 'script-loader!slick-carousel';
import 'script-loader!sticky-scroll';
import 'script-loader!smartmenus';
import 'script-loader!table2csv';
import 'hamburgers/dist/hamburgers.css';
import retina from 'retinajs';
import AOS from 'aos';
import velocity from 'velocity-animate';
import fancybox from '@fancyapps/fancybox';
import 'smartmenus/dist/css/sm-core-css.css';
import 'smartmenus/dist/css/sm-simple/sm-simple.scss';
import 'slick-carousel/slick/slick.scss';
import 'slick-carousel/slick/slick-theme.scss';
import '../scss/entry.scss';
import { controlTabbedContent } from './controlTabbedContent';
import { counter } from './counter';
import { responsiveCustomText } from './responsiveCustomText';
import { lightbox } from './lightbox';
import { controlAddToCalendar } from './controlAddToCalendar';
import { addAsterisks } from './asteriskForSurvey';

jQuery(document).ready(function($) {



	// united states svg map
	$("path, circle").hover(function(e) {
		$('#state-info-box').css('display','block');
		$('#state-info-box').html($(this).data('info'));
	});
		
	$("path, circle").mouseleave(function(e) {
		$('#state-info-box').css('display','none');
	});
		
	$(document).mousemove(function(e) {
		// $('#state-info-box').css('top',e.pageY-$('#state-info-box').height()-35);
		$('#state-info-box').css('top',e.clientY-$('#state-info-box').height()-30);
		$('#state-info-box').css('left',e.pageX-($('#state-info-box').width())/2);
	}).mouseover();
		
	var ios = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
	if(ios) {
		$('a').on('click touchend', function(e) { 
			if (e.target.closest('.svg-map-container')) {
				var link = $(this).attr('href');   
				window.open(link,'_blank');
				return false;
			}
		});
	}












  






	const throttle = (func, delay) => {
		let prev = 0;
		return (...args) => {
			let now = new Date().getTime();

			if (now - prev > delay) {
				prev = now;
				return func(...args);
			}
		}
	}
	
	// animate on scroll init
	AOS.init({ once: true, duration: 700 });
	$(window).on("scroll", throttle( function() { AOS.refresh() }, 500));

	// tab content block
	$('.ffw-tabber').on('click', function() {
		$(this).siblings().removeClass('active');
	});
	
	// desktop header search toggle
	$('li.dt-search a').on('click', function() {
		$(this).children().toggleClass('fa-search fa-times');
		$('.dt-search-wrap').toggleClass('open closed');
		$('.primary-menu-item').toggleClass('search-open');
	});

	$('.mobile-search a').on('click', function() {
		$(this).children().toggleClass('fa-search fa-times');
		$('.mobile-search-wrap').toggleClass('open closed');
		$('.header-lower').toggleClass('search-active');
		$('.hamburger').toggleClass('search-active');
		// $('.primary-menu-item').toggleClass('search-open');
	});


	// bootstrap popovers -- see: https://getbootstrap.com/docs/5.0/components/popovers/ for more info
	$(document).ready(function() {
		if($('[data-bs-toggle="popover"]')[0]) {
			var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
			var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
				return new bootstrap.Popover(popoverTriggerEl)
			});
			// dismiss the popover on click
			var popover = new bootstrap.Popover(document.querySelector('.popover-dismiss'), {
				trigger: 'focus'
			});
		}
	});

	// bootstrap tooltips -- see: https://getbootstrap.com/docs/5.0/components/tooltips/ for more info
	$(document).ready(function() {
		if($('[data-bs-toggle="tooltip"]')[0]) {
			var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
			var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
				return new bootstrap.Tooltip(tooltipTriggerEl)
			});
		}
	});

	// hamburger stuffs
	var forEach=function(t,o,r){if("[object Object]"===Object.prototype.toString.call(t))for(var c in t)Object.prototype.hasOwnProperty.call(t,c)&&o.call(r,t[c],c,t);else for(var e=0,l=t.length;l>e;e++)o.call(r,t[e],e,t)};
	var hamburgers = document.querySelectorAll(".hamburger");
	if (hamburgers.length > 0) {
		forEach(hamburgers, function(hamburger) {
			hamburger.addEventListener("click", function() {
				this.classList.toggle("is-active");
				const mobileSearch = document.querySelector('.mobile-search');

				if (mobileSearch) {
					mobileSearch.classList.toggle('hamburger-active');
				}
			}, false);
		});
	}

	// accordions
	$('.accordion-toggle').on('click', function() {
		$(this).toggleClass('is-active');
		$(this).parent().find('.accordion-content').slideToggle('fast');
	});

	$('.title-accordion-toggle').on('click', function() {
		$(this).find('.title-accordion-circle').toggleClass('is-active');
		$(this).parent().find('.title-accordion-content').slideToggle('fast');
	})

	// header search toggle
	$('#search-toggle').on('click', function() {
		$(this).toggleClass('glass').toggleClass('close');
		$('#search-box').toggleClass('open');
		$('#top-search').focus();
	});

	// fancybox
	$(document).ready(function() {
		$("a.fancybox").fancybox({
			'transitionIn'	:	'elastic',
			'transitionOut'	:	'elastic',
			'speedIn'		:	600, 
			'speedOut'		:	200, 
			'overlayShow'	:	false
		});
	});

	// add responsive class to all images
	$(function() {
		$('img').addClass('img-fluid');
	});

	// primary menu
	$(function() {
		$('.sm').smartmenus({
			subMenusSubOffsetX: 1,
			subMenusSubOffsetY: -3
		});
	});

	// primary navigation toggle
	$('.nav-toggle').on('click', function() {
		$('.primary-nav-wrap').slideToggle('fast');
	});

	// scroll back to top button
	$(document).ready(function($){
		// browser window scroll (in pixels) after which the "back to top" link is shown
		var offset = 300,
			//browser window scroll (in pixels) after which the "back to top" link opacity is reduced
			offset_opacity = 1200,
			//duration of the top scrolling animation (in ms)
			scroll_top_duration = 300,
			//grab the "back to top" link
			$back_to_top = $('.cd-top');
		//hide or show the "back to top" link
		$(window).scroll(function(){
			( $(this).scrollTop() > offset ) ? $back_to_top.addClass('cd-is-visible') : $back_to_top.removeClass('cd-is-visible cd-fade-out');
			if( $(this).scrollTop() > offset_opacity ) { 
				$back_to_top.addClass('cd-fade-out');
			}
		});
		//smooth scroll to top
		$back_to_top.on('click', function(event){
			event.preventDefault();
			$('body,html').animate({
				scrollTop: 0 ,
				}, scroll_top_duration
			);
		});
	});

	// acf slider
	$('.slider-prev').on('click', function(){
		$(this).parent().prev().slick('slickPrev');
	});
	$('.slider-next').on('click', function(){
		$(this).parent().prev().slick('slickNext');
	});

	// header scroll effects
	$(document).ready(function($){
		var offset = 106,
			header = $('#masthead');
		$(window).scroll(function(){
			($(this).scrollTop() > offset ) ? header.addClass('fixed-header') : header.removeClass('fixed-header');
		});
	});

	function headerEffects() {
		var navbar = $('#masthead');
		$(window).scroll(function () {
			var scrollPosition = $(window).scrollTop();
			if (scrollPosition > 130)
				navbar.addClass('site-header--scrolled');
			else
				navbar.removeClass('site-header--scrolled');
		});
	}
	(function(){
		var doc = document.documentElement;
		var w = window
		var prevScroll = w.scrollY || doc.scrollTop;
		var curScroll;
		var direction = 0;
		var prevDirection = 0;
		var header = document.getElementById('masthead');
		var notificationBar = document.querySelector('.header-notification-bar');
		
		if (prevScroll > 170) {
			header.classList.add('solid');
		}

		var checkScroll = function() {
			curScroll = w.scrollY || doc.scrollTop;
			if (curScroll > prevScroll) { 
				//scrolled up
				direction = 2;
			}
			else if (curScroll < prevScroll) { 
				//scrolled down
				direction = 1;
			}
			if (direction !== prevDirection) {
				toggleHeader(direction, curScroll);
			}
			prevScroll = curScroll;
		};
		var toggleHeader = function(direction, curScroll) {
			if (direction === 2 && curScroll > 170) { 
				//replace 52 with the height of your header in px
				header.classList.add('solid');
				if (notificationBar) {
					notificationBar.classList.add("show");
				}
				prevDirection = direction;
			}
			else if (direction === 1 && curScroll < 170) {
				header.classList.remove('solid');
				if (notificationBar) {
					notificationBar.classList.remove("show");
				}
				prevDirection = direction;
			}
		};
		window.addEventListener('scroll', checkScroll);
	})();

	// custom 404
	$(function () {
		$().ready(function () {
			(function () {
				var requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;
				window.requestAnimationFrame = requestAnimationFrame
			})();
			var canvas = document.getElementById('canvas-404');
			if (canvas === null)return;
			setTimeout(function () {
				$('.js-toaster_lever').delay(200).animate({top: 30}, 100);
				$('.js-toaster_toast').removeClass('js-ag-hide').addClass('js-ag-animated js-ag-bounce-in-up')
			}, 800);
			var ctx = canvas.getContext("2d"),
				loading = true;
				canvas.height = 210;
				canvas.width = 300;
			var parts = [],
				minSpawnTime = 100,
				lastTime = new Date().getTime(),
				maxLifeTime = Math.min(6000, (canvas.height / (1.5 * 60) * 1000)),
				emitterX = canvas.width / 2 - 50,
				emitterY = canvas.height - 10,
				smokeImage = new Image();
			function spawn() {
				if (new Date().getTime() > lastTime + minSpawnTime) {
					lastTime = new Date().getTime();
					parts.push(new smoke(emitterX, emitterY))
				}
			}
			function render() {
				if (loading) {
					load();
					return false
				}
				var len = parts.length;
				ctx.clearRect(0, 0, canvas.width, canvas.height);
				while (len--)if (parts[len].y < 0 || parts[len].lifeTime > maxLifeTime) {
					parts.splice(len, 1)
				} else {
					parts[len].update();
					ctx.save();
					var offsetX = -parts[len].size / 2, offsetY = -parts[len].size / 2;
					ctx.translate(parts[len].x - offsetX, parts[len].y - offsetY);
					ctx.rotate(parts[len].angle / 180 * Math.PI);
					ctx.globalAlpha = parts[len].alpha;
					ctx.drawImage(smokeImage, offsetX, offsetY, parts[len].size, parts[len].size);
					ctx.restore()
				}
				spawn();
				requestAnimationFrame(render)
			}
			function load() {
				if (loading) {
					setTimeout(load, 3000);
				} else {
					render();
				}
			}
			render();
		});
	});

	// csv exports
	$(document).ready(function() {
		$('#example-dl').on('click', function() {
			$("#example-csv").table2csv({
				filename: 'example'
			});
		});
	});

	// Controlling Tabbed Content Block(s)

	const tabbedContentContainers = Array.from(document.querySelectorAll('.tabbed-content__container'));

	if (tabbedContentContainers.length > 0) {
		tabbedContentContainers.forEach(container => controlTabbedContent(container));
	}

	// Stat Columns Counter

	const countups = Array.from(document.querySelectorAll("[data-countup]"));

	if (countups.length > 0) {
		countups.forEach(countup => {
			const countupNumber = countup.textContent;
			const countupDuration = parseInt(countup.dataset.countup);
			counter(countup, countupNumber, countupDuration);
		})
	}

	// Brushstroke Cards Counter

	const brushCounters = Array.from(document.querySelectorAll("[data-brush-counter]"));

	if (brushCounters.length > 0) {
		brushCounters.forEach(brushCounter => {
			const brushCounterNumber = brushCounter.textContent;
			const brushCounterDuration = parseInt(brushCounter.dataset.brushCounter);
			counter(brushCounter, brushCounterNumber, brushCounterDuration);
		})
	}

	// Timeline Slider 

	$('.timeline__timeline').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		prevArrow: $('.timeline__arrows--prev'),
		nextArrow: $('.timeline__arrows--next'),
		infinite: false,
		responsive: [
			{
				breakpoint: 767,
				settings: {
					adaptiveHeight: true
				}
			}
		]
	})

	// Shrink Custom Text if in px
	const allCustomTexts = Array.from(document.querySelectorAll('.custom-text'));

	if (allCustomTexts.length > 0 && window.innerWidth < 767) {
		responsiveCustomText(allCustomTexts);
	}

	// Slider Content Slider
	$('.slider-content__slides').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		prevArrow: $('.slider-content__arrows--prev'),
		nextArrow: $('.slider-content__arrows--next'),
		infinite: false,
		responsive: [
			{
				breakpoint: 767,
				settings: {
					adaptiveHeight: true
				}
			}
		]
	})

	// Resources Selection SLider
	$('.resources-slider').slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		prevArrow: $('.resources-selection__arrows--prev'),
		nextArrow: $('.resources-selection__arrows--next'),
		infinite: false,
		adaptiveHeight: false,
		responsive: [
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1
				}
			}
		]
	});

	// Involvement Selection Slider
	$('.involvement-slider').slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		prevArrow: $('.involvement-selection__buttons--prev'),
		nextArrow: $('.involvement-selection__buttons--next'),
		infinite: false,
		adaptiveHeight: false,
		responsive: [
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1
				}
			}
		]
	})

	// Mega Menu hovering
	const allItems = Array.from(document.querySelectorAll('.primary-menu-item'));

	if (allItems.length > 0) {
		const menuOverlay = document.querySelector('.menu-open-overlay');

		allItems.forEach(item => {
			const itemMegaMenu = item.querySelector('.primary-menu-mega-container');

			if (itemMegaMenu) {
				const menuTriangle = item.querySelector('.primary-menu-mega-triangle');
				item.addEventListener('mouseenter', (e) => {
					itemMegaMenu.classList.add('menu-active');
					menuTriangle.classList.add('menu-active');
					itemMegaMenu.classList.remove('menu-hiding');
					menuTriangle.classList.remove('menu-hiding');
					menuOverlay.classList.add('menu-open');
					item.addEventListener('mouseleave', (e) => {
						itemMegaMenu.classList.add('menu-hiding');
						menuTriangle.classList.add('menu-hiding');
						itemMegaMenu.classList.remove('menu-active');
						menuTriangle.classList.remove('menu-active');
						menuOverlay.classList.remove('menu-open');
						setTimeout(() => {
							itemMegaMenu.classList.remove('menu-hiding');
							menuTriangle.classList.remove('menu-hiding');
						}, 200);
					})
				})
			}
		})
	}

	// Department Accordions
	$('.department-accordions__accordion--toggle').on('click', function() {
		$(this).find('.department-accordions__accordion--circle').toggleClass('is-active');
		$(this).siblings('.department-accordions__accordion--content').slideToggle('fast');
	})

	// Survey Accordions
	// $(document).on("facetwp-loaded", function() {
	// 	$(".company-survey__column--toggle").on("click", function() {
	// 		$(this).toggleClass("active-toggle");
	// 		$(this).siblings(".company-survey__result--column-hidden").slideToggle('fast');
	// 	})
	// })

	// Lightbox
	const lbContainer = document.querySelector('.lightbox__container');

	if (lbContainer) {
		lightbox(lbContainer);
	}

	// Mobile Menu
	const goToPage = (e) => {
		if (e.target.classList.contains('sub-arrow')) {
			return;
		} else {
			e.stopPropagation();
			const goToLink = e.target.href;
			window.location.assign(goToLink);
		}
	}
	
	const allMobileSubmenu = Array.from(document.querySelectorAll('.primary-mobile-menu > li.menu-item-has-children'));
	
	if (allMobileSubmenu.length > 0) {
		setTimeout(() => {
			allMobileSubmenu.forEach(submenu => {
				const submenuItem = submenu.querySelector(".has-submenu");
		
				if (submenuItem) {
					submenuItem.addEventListener('click', (e) => goToPage(e));
				}
			})
		}, 300);
	}

	// Links scrolling
	$('.links__link.link-anchor').on('click', function (event) {
		event.preventDefault();
	
		$('html, body').animate({
			scrollTop: $($.attr(this, 'href')).offset().top - 120
		});
	});

	// Parameters
	const setUTMParameters = (paramsContainer, paramsForm) => {
		const formParameters = Array.from(paramsContainer.querySelectorAll('.form-parameters-parameter'));

		if (formParameters.length > 0) {
			const searchObject = window.location.search;
			const searchParams = new URLSearchParams(searchObject);

			formParameters.forEach(param => {
				const parameterName = param.dataset.parameterName;
				const thisParamValue = searchParams.get(parameterName);
				
				if (thisParamValue) {
					const thisField = paramsForm.querySelector(`input[value="${parameterName}"]`);

					if (thisField) {
						thisField.value = thisParamValue;

					}
				}
			})
		}
	}

	const formParametersContainer = document.querySelector('.form-parameters');
	
	if (formParametersContainer) {
		const formID = formParametersContainer.dataset.formId;

		if (formID) {
			const form = document.querySelector(`#gform_${formID}`);
			setTimeout(() => {
				setUTMParameters(formParametersContainer, form)
		 	}, 1);
		}
	}

	const allATCButtons = Array.from(document.querySelectorAll('.atc__button'));

	if (allATCButtons.length > 0) {
		allATCButtons.forEach(button => controlAddToCalendar(button));
	}

	// Adding Asterisks to Company Survey
	const surveyBlock = document.querySelector(".company-survey__container");

	if (surveyBlock) {
		addAsterisks();
	}

});